<template>
    <div>
        <p-tabs v-if="livedates" class="pad-some pad-fix score-scroll" v-model="activedate" :key="0" v-on:change="$store.dispatch('scoring/set_tab_state',$event)">
            <p-tab-item v-for="dt in livedates.dates" :key="dt.date">
                <template slot="header"><span class="is-uppercase">{{format(dt.date)}}</span></template>
                <div class="score-panel" v-for="r in dt.rounds" :key="r.id">
                    <div class="score-round">
                        <span class="round-name">{{r.name}}</span> 
                    </div>
                    <template  v-for="cls in r.classes">
                        <div @click="$router.push(`/${compkey}/live/${cls.racid}`)" class="score-class" :key="cls.racid">
                            <span class="is-size-5"> {{cls.label}} </span>
                            <span class="round-class-total"></span>
                        </div>
                    </template>
                </div>
            </p-tab-item>
        </p-tabs>
        <footer class="score-footer is-size-5">
            <div class="score-footer-text  is-mobile ">
                
            </div>
        </footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment'
import PTabs from '../../tabs/Tabs.vue'
import PTabItem from '../../tabs/TabItem.vue'


export default {
    name: 'LiveRounds',
    components: { PTabs, PTabItem },
    props: ['cid','acid', 'ceid', 'compname', 'compkey'],
    data() {
        return {
            activedate: 0,
        }
    },
    mounted() {
        this.$store.dispatch('scoring/get_live_dates', this.$route.params.key)
        this.$store.dispatch('scoring/set_prev_route',{})

        .then(() => {
            console.log('Got live comp')
        })
        let last = this.$store.state.scoring.tabcache[this.$route.path]
        if(last) 
            this.activedate = last

    },
    computed: {
        ...mapGetters({ livedates: 'scoring/livedates'}),
    },
    methods: {
        format(str) {
            return moment(str).format('ddd Do MMM')
        },
        time(str) {
            return moment(str).format('HH:mm')
        },
    }
}
</script>

<style>
.score-scroll { height: calc(100vh - 54px); overflow: hidden; }
</style>